/* auto-generated: @mui/icons-material */
import Base from '@mui/icons-material/KeyboardArrowDown';
import {withMuiAdapter} from '@common/icons/with-mui-adapter';

export const KeyboardArrowDownIcon = withMuiAdapter(Base, 'KeyboardArrowDown');
